"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Progress = {
    parts: ['track'],
    baseStyle: {
        track: {
            borderRadius: 'full',
        },
    },
    defaultProps: {
        size: 'sm',
    },
};
exports.default = Progress;
